import { onMounted } from 'vue'

/**
 * Composable to override z-index of third-party widgets that use Shadow DOM
 * This is necessary because regular CSS cannot penetrate Shadow DOM boundaries
 */
export function useZIndexOverride() {
  onMounted(() => {
    overrideProductFruitsChatZIndex()
  })
}

/**
 * Injects z-index override styles into Product Fruits shadow root
 */
function overrideProductFruitsChatZIndex() {
  const injectStyles = () => {
    const container = document.querySelector('.productfruits--container')
    if (!container?.shadowRoot) return false

    // Check if styles already injected
    if (container.shadowRoot.querySelector('#custom-z-index-override')) return true

    const style = document.createElement('style')
    style.id = 'custom-z-index-override'
    style.textContent = `
      .button-launcher {
        z-index: 1200 !important;
      }
    `
    container.shadowRoot.appendChild(style)
    return true
  }

  // Try immediately
  if (injectStyles()) return

  // Use MutationObserver to catch when Product Fruits loads
  const observer = new MutationObserver(() => {
    if (injectStyles()) {
      observer.disconnect()
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })

  // Cleanup observer after 10 seconds
  setTimeout(() => observer.disconnect(), 10000)
}
